import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import DatePicker from 'react-datepicker';
import NumberFormat from 'react-number-format';
import { Link, useHistory, useParams, withRouter } from 'react-router-dom';
import { Popup } from 'reactjs-popup';
import CustomSelect from '../../../../../Util/CustomSelect/CustomSelect';
import TextEditor from '../../../../../Util/TextEditor/TextEditor';
import WarningDialogue from '../../../../../Util/WarningDialogue';
import { EVENT_OCCASION, EVENT_STATUS, LEAD_STATUS, PAID_TYPE, phoneNumberMask, validateEmail } from '../../../../../Util/helper';
import add from "../../../../../assets/add-icon.svg";
import backArrow from '../../../../../assets/arrow-back.svg';
import fileIcon from '../../../../../assets/file-icon.svg';
import sendIcon from '../../../../../assets/send-white.png';
import trashIcon from '../../../../../assets/trash-white.png';
import uploadIcon from '../../../../../assets/upload-white.png';
import { config } from '../../../../../config';
import axiosApi from '../../../../../core/interceptor/interceptor';
import { messages } from '../../../../../messages';
import AutoPlaceComplete from '../CreateEvent/AutoPlaceComplete';
import Invoice from '../Invoices/Invoices';
import Tickets from '../Tickets/Tickets';
import "./AddEvent.css";

function AddEvent(props) {
  const id = useParams().id;
  const childFunc = React.useRef(null)
  const history = useHistory();
  const scanTicket = props.history.location.search.indexOf('?ticket') !== -1 ? true : false;
  const [formData, setFormData] = useState({
    title: '',
    start_date_time: new Date(),
    end_date_time: new Date(),
    detail: '',
    type: 'public',
    paid_type: 'free',
    ticket_price: 0,
    occasion: '',
    other_occasion: '',
    budget: 0,
    no_of_guest: 0,
    venue_id: 0,
    venue_name: '',
    status: 'active',
    captured_date_time: new Date(),
    booking_start_date: null,
    booking_deadline: null,
    image: '',
    client_name: '',
    client_email: '',
    client_phone: '',
    client_address: '',
    team_type: '',
    approx_teams: 0,
  });
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [venues, setVenues] = useState([]);
  const [docs, setDocs] = useState([]);
  const [openWarningPopup, setOpenWarningPopup] = useState(false);
  const [popupContent, setPopupContent] = useState({});
  const [openFilePopup, setOpenFilePopup] = useState(false);
  const [savedDocs, setSavedDocs] = useState([]);
  const [showSavedDocs, setShowSavedDocs] = useState(false);
  const [errors, setErrors] = useState({
    title: '',
    image: '',
  });
  const [tab, setTab] = useState(props.history.location.search.indexOf('?ticket') !== -1 ? 'ticket' : 'detail');
  const [selectedFile, setSelectedFile] = useState('');
  const [img, setImg] = useState('');
  const [plusIcon, setPlusIcon] = useState(<div className="add-icon"><FontAwesomeIcon icon={faPlus} /></div>);
  const [showBackTicket, setShowBackTicket] = useState(false);
  const eventsOccasions = [...EVENT_OCCASION, { id: EVENT_OCCASION.length + 1, name: 'Tournament' },]

  const getVenues = () => {
    axiosApi.get(`${config.apiUrl}/web-content/venues/active`)
      .then((res) => {
        if (res && res.data && res.data.data) {
          setVenues([{ id: '', name: 'TBD' }, ...res.data.data]);
        }
      })
  }

  const getDocs = () => {
    axiosApi.get(`${config.apiUrl}/events/docs/${id}`)
      .then((res) => {
        setDocs(res?.data?.data);
      })
  }

  const getEvent = (id) => {
    axiosApi.get(`${config.apiUrl}/events/${id}`)
      .then((res) => {
        if (res && res.data && res.data.data) {
          const data = res.data.data;
          setFormData((prev) => ({
            ...prev,
            title: data?.title,
            start_date_time: new Date(data?.start_date_time),
            end_date_time: new Date(data?.end_date_time),
            booking_start_date: data?.booking_start_date ? new Date(moment(data?.booking_start_date).format('YYYY/MM/DD')) : null,
            booking_deadline: data?.booking_deadline ? new Date(moment(data?.booking_deadline).format('YYYY/MM/DD')) : null,
            image: data?.image,
            detail: data?.detail && data?.detail !== 'null' ? data?.detail : '',
            type: data?.type,
            paid_type: data?.paid_type,
            ticket_price: data?.ticket_price ? data?.ticket_price : 0,
            occasion: data?.occasion ? data?.occasion : '',
            other_occasion: data?.other_occasion,
            team_type: data?.team_type,
            approx_teams: data?.approx_teams,
            budget: data?.budget,
            no_of_guest: data?.no_of_guest ? data?.no_of_guest : 0,
            venue_id: data?.venue_id ? data?.venue_id : 0,
            venue_name: data?.event_venue?.name,
            client_name: data?.client_name ? data?.client_name : '',
            client_email: data?.client_email ? data?.client_email : '',
            client_phone: data?.client_phone ? data?.client_phone : '',
            client_address: data?.client_address ? data?.client_address : '',
            status: data?.status
          }))
          if (data.image) {
            setImg(<img src={`${data.image_url}`} alt={data.image} />);
            setPlusIcon('');
          }
        }
      })
  }
  const handleFormChange = (e) => {
    if (e.target.name === 'venue_id') {
      setFormData((prev) => ({
        ...prev,
        [e.target.name]: e.target.value,
        venue_name: e.target.venue_name
      }))
    } else if (e.target.name === 'occasion') {
      setFormData((prev) => ({
        ...prev,
        [e.target.name]: e.target.value,
        other_occasion: '',
        team_type: '',
        approx_teams: 0,
      }))
    } else if (e.target.name === 'type') {
      setFormData((prev) => ({
        ...prev,
        [e.target.name]: e.target.value,
        paid_type: 'free',
        ticket_price: 0,
      }))
    } else if (e.target.name === 'paid_type') {
      setFormData((prev) => ({
        ...prev,
        [e.target.name]: e.target.value,
        ticket_price: 0,
      }))
    } else {
      setFormData((prev) => ({
        ...prev,
        [e.target.name]: e.target.value
      }))
    }
  }

  const handleValidation = () => {
    let errorArr = {};
    let formIsValid = true;

    if (!formData['title']?.trim()) {
      formIsValid = false;
      errorArr["title"] = messages && messages.emptyTitle;
    }
    // if (!formData.no_of_guest) {
    //   formIsValid = false;
    //   errorArr["no_of_guest"] = messages && messages.emptyNoOfMatch;
    // }
    // if (formData.no_of_guest && formData.no_of_guest < 1) {
    //   formIsValid = false;
    //   errorArr["no_of_guest"] = messages && messages.guestGreaterThanOne;
    // }
    if (!formData.start_date_time) {
      formIsValid = false;
      errorArr["start_date_time"] = messages && messages.empty_event_start_time;
    }
    if (!formData.end_date_time) {
      formIsValid = false;
      errorArr["end_date_time"] = messages && messages.empty_event_end_time;
    }
    if (formData.start_date_time && formData.end_date_time && (moment(formData.start_date_time).unix() > moment(formData.end_date_time).unix())) {
      formIsValid = false;
      errorArr['start_date_time'] = messages && messages.event_end_time_error;
    }

    // if (formData.type === 'public' && !formData.booking_start_date) {
    //   formIsValid = false;
    //   errorArr['booking_start_date'] = messages && messages.bookingStartErr;
    // }

    // if (formData.type === 'public' && !formData.booking_deadline) {
    //   formIsValid = false;
    //   errorArr['booking_deadline'] = messages && messages.bookingEndErr;
    // }
    // if (!formData.detail) {
    //   formIsValid = false;
    //   errorArr["detail"] = messages && messages.emptyEventDetail;
    // }
    if (!formData.type) {
      formIsValid = false;
      errorArr["type"] = messages && messages.emptyEventType;
    }
    if (!formData.paid_type) {
      formIsValid = false;
      errorArr["paid_type"] = messages && messages.emptySelect;
    }
    if (formData.type === 'public' && formData.paid_type === 'paid' && !formData.ticket_price) {
      formIsValid = false;
      errorArr["ticket_price"] = messages && messages.emptyField;
    }
    // if (!formData.venue_id) {
    //   formIsValid = false;
    //   errorArr["venue_id"] = messages && messages.emptyEventvenue;
    // }
    // if (!formData.budget) {
    //   formIsValid = false;
    //   errorArr["budget"] = messages && messages.emptyField;
    // }
    if (!formData.occasion) {
      formIsValid = false;
      errorArr["occasion"] = messages && messages.emptyOccasion;
    }
    if (formData.occasion === "Other" && !formData.other_occasion?.trim()) {
      formIsValid = false;
      errorArr["other_occasion"] = messages && messages.emptyField;
    }
    if (formData.occasion === "Tournament" && !formData.team_type?.trim()) {
      formIsValid = false;
      errorArr["team_type"] = messages && messages.emptyField;
    }
    if (formData.occasion === "Tournament" && !formData.approx_teams) {
      formIsValid = false;
      errorArr["approx_teams"] = messages && messages.emptyField;
    }
    // if (!formData.client_name?.trim()) {
    //   formIsValid = false;
    //   errorArr["client_name"] = messages && messages.emptyField;
    // }
    // if (!formData.client_email?.trim()) {
    //   formIsValid = false;
    //   errorArr["client_email"] = messages && messages.emptyField;
    // }
    if (formData.client_email && !validateEmail((formData.client_email).trim())) {
      formIsValid = false;
      errorArr["client_email"] = messages && messages.invalidEmail;
    }
    // if (!formData.client_phone) {
    //   formIsValid = false;
    //   errorArr["client_phone"] = messages && messages.emptyField;
    // }
    if (formData.client_phone && formData.client_phone.replace(/\D/g, '').length < 10) {
      formIsValid = false;
      errorArr['client_phone'] = messages && messages.phoneLength;
    }
    // if (!formData.client_address?.trim()) {
    //   formIsValid = false;
    //   errorArr["client_address"] = messages && messages.emptyField;
    // }
    if (formData.booking_start_date && moment(formData.booking_start_date).format() > moment(formData.start_date_time).format()) {
      formIsValid = false;
      errorArr["booking_start_date"] = messages && messages.bookingStartDateErr;
    }
    if (formData.booking_deadline && moment(formData.booking_deadline).format() > moment(formData.start_date_time).format()) {
      formIsValid = false;
      errorArr["booking_deadline"] = messages && messages.bookingDeadlineErr;
    }
    setErrors(errorArr);
    return formIsValid;
  }

  const handleSubmit = () => {
    setFormSubmitted(true);
    if (handleValidation()) {
      const data = new FormData();
      data.append('title', formData?.title);
      data.append('start_date_time', formData.start_date_time);
      data.append('end_date_time', formData?.end_date_time);
      if (formData.detail) data.append('detail', formData.detail);
      data.append('type', formData?.type);
      data.append('paid_type', formData.paid_type);
      data.append('ticket_price', formData.ticket_price);
      data.append('occasion', formData?.occasion);
      if (formData.other_occasion) data.append('other_occasion', formData.other_occasion);
      if (formData.team_type) data.append('team_type', formData.team_type);
      if (formData.approx_teams) data.append('approx_teams', formData.approx_teams);
      data.append('budget', formData?.budget);
      data.append('no_of_guest', formData.no_of_guest);
      data.append('venue_id', formData.venue_id);
      data.append('status', formData?.status);
      data.append('captured_date_time', formData?.captured_date_time);
      if (formData?.booking_start_date) data.append('booking_start_date', formData?.booking_start_date);
      if (formData?.booking_deadline) data.append('booking_deadline', formData?.booking_deadline);
      data.append('image', formData?.image);
      if (formData?.client_name) data.append('client_name', formData?.client_name);
      if (formData?.client_email) data.append('client_email', formData.client_email);
      if (formData?.client_phone) data.append('client_phone', formData.client_phone);
      if (formData?.client_address) data.append('client_address', formData.client_address);

      data.append('name', formData?.title);
      if (selectedFile && selectedFile.name) {
        data.append('file', selectedFile);
      }
      if (id) {
        axiosApi.put(`${config.apiUrl}/events/${id}`, data)
          .then((res) => {
            history.push('/admin/events');
          })
      } else {
        axiosApi.post(`${config.apiUrl}/events/create`, data)
          .then((res) => {
            history.push('/admin/events');
          })
      }
    }
  }

  useEffect(() => {
    handleValidation();
    //eslint-disable-next-line
  }, [formData])

  useEffect(() => {
    if (id) {
      getEvent(id);
    }
  }, [id])

  useEffect(() => {
    getVenues();
  }, [])

  useEffect(() => {
    if (props && props.location && props.location.state && props.location.state.date) {
      setFormData((prev) => ({
        ...prev,
        start_date_time: props.location.state.date,
        end_date_time: props.location.state.date
      }))
    }
  }, [props?.location])

  useEffect(() => {
    if (tab === 'doc' && id > 0) {
      getDocs(id);
    }
    //eslint-disable-next-line
  }, [tab])

  const getPlace = (place) => {
    if (place?.addressVal) {
      setFormData((prev) => ({
        ...prev,
        client_address: place?.addressVal
      }))
    } else {
      setFormData((prev) => ({
        ...prev,
        client_address: place
      }))
    }
  }

  const onEventImgChange = (e) => {
    if (e.target.type === 'file' && e.target.files && e.target.files[0]) {
      const file = e.target.files[0];
      setSelectedFile(file);
      setImg(<img src={`${URL.createObjectURL(file)}`} alt='' />);
      setPlusIcon(<div className="add-icon img-selected"><FontAwesomeIcon icon={faPlus} /></div>);
    }
  }

  const onFileChange = (e) => {
    if (e.target.files && e.target.files.length) {
      let data = new FormData();
      data.append('name', e.target.files[0].name);
      data.append('event_id', id);
      data.append('file', e.target.files[0]);
      data.append('type', 'local');
      data.append('create_by', 'admin');
      axiosApi.post(`${config.apiUrl}/events/doc`, data)
        .then((res) => {
          const temp = [...docs];
          temp.push(res?.data?.data)
          setDocs(temp);
          setOpenFilePopup(false);
        })
    }
  }

  const handleDelete = (e, data) => {
    e.stopPropagation();
    setOpenWarningPopup(true);
    setPopupContent({
      header: 'Confirm',
      description: 'Are you sure, you want to remove?',
      icon: '',
      type: 'confirm',
      action: () => {
        axiosApi.delete(`${config.apiUrl}/events/doc/${data?.id}`, { data: { source: data } })
          .then((res) => {
            if (res) {
              getDocs();
              setOpenWarningPopup(false);
            }
          })
          .catch((err) => {
            setOpenWarningPopup(false);
          })
      }
    });
  }

  const getSavedDocs = () => {
    axiosApi.get(`${config.apiUrl}/documents/docs`)
      .then((res) => {
        setSavedDocs(res?.data?.data);
      })
  }

  const handleSavedDocs = () => {
    getSavedDocs();
    setShowSavedDocs(true);
  }

  const savedDoc = (data) => {
    if (data) {
      const payload = {
        doc_name: data?.file_name,
        type: 'saved',
        event_id: id,
        created_by: 'admin',
      }
      axiosApi.post(`${config.apiUrl}/events/save-doc`, payload)
        .then((res) => {
          const temp = [...docs];
          temp.push(res?.data?.data)
          setDocs(temp);
          setOpenFilePopup(false);
        })
    }
  }

  const sendDocToClient = (e, doc) => {
    e.stopPropagation();
    setOpenWarningPopup(true);
    setPopupContent({
      header: 'Confirm',
      description: 'Are you sure, you want to send?',
      icon: '',
      type: 'confirm',
      action: () => {
        const data = formData;
        data.doc_name = doc?.doc_name;
        data.type = doc?.type;
        data.doc_id = doc?.id;
        axiosApi.post(`${config.apiUrl}/events/send-doc`, data)
          .then((res) => {
            if (res) {
              getDocs();
              setOpenWarningPopup(false);
            }
          })
          .catch((err) => {
            setOpenWarningPopup(false);
          })
      }
    });
  }

  const handleUpload = () => {
    setOpenFilePopup(true);
  }

  const isTicketInfoOpen = (cb) => {
    setShowBackTicket(cb);
  }

  return (
    <>
      <div className="adminMenuContainer addMenulist mul-admin-container">
        <div className="content-wrapper menu-wrapper">
          <div className="heading-wrapper ns-header-wrapper">
            <button onClick={() => showBackTicket ? setShowBackTicket(false) : history.goBack()} className='btn with-icon'> <img src={backArrow} alt="" /> Back to {showBackTicket ? `Tickets` : `Events`}</button>
            <div className="left">
              <h1 className="heading">
                {
                  scanTicket ? 'Tickets' : 'Events'
                }
              </h1>
            </div>
          </div>
          <div className="admin-menu-section-wrapper p0">
            <div className="">
              {id && <div className="ns-tabs-outer">
                <div className="cs-new-tabs cs-new-tabs-add">
                  <ul>
                    {
                      !scanTicket && <>
                        <li onClick={() => setTab('detail')} className={`${tab === 'detail' ? 'active' : ''}`}>Event Details</li>
                        <li onClick={() => setTab('doc')} className={`${tab === 'doc' ? 'active' : ''}`}>Documents</li>
                        <li onClick={() => setTab('invoice')} className={`${tab === 'invoice' ? 'active' : ''}`}>Invoice</li>
                      </>
                    }

                    {formData.type === 'public' && <li onClick={() => setTab('ticket')} className={`${tab === 'ticket' ? 'active' : ''}`}>Tickets</li>}
                  </ul>
                  {tab === 'invoice' && <button className='btn with-icon' onClick={() => childFunc.current()} ><img src={add} />Add Invoice</button>}
                  {tab === 'doc' && <button className='btn with-icon upload-btn' onClick={() => handleUpload()}>
                    <input type="file" onChange={(e) => onFileChange(e)} name="file" id="upload-invoice" accept="image/png, image/jpeg, application/pdf" />
                    <img src={uploadIcon} alt="" />
                    {/* <img src={pencilIcon} alt="" /> */}
                    {/* use above img for edit icon */}
                    Upload Doc
                  </button>}
                </div>
              </div>}

              <div className="mul-events-body mul-events-body-add-events">
                {tab === 'detail' && <div className="mul-form">
                  <div className="cs-row">
                    <div className="cs-col-12 new-sec-title">
                      <h2>Event Info</h2>
                    </div>
                    <div className="cs-col-4 mob-fluid">
                      <div className="mul-input-field">
                        <label htmlFor="">Event Name<sup>*</sup></label>
                        <input
                          name='title'
                          value={formData?.title}
                          onChange={(e) => handleFormChange(e)}
                          type="text"
                          placeholder='Event Name'
                        />
                        <span className="error">{formSubmitted && errors["title"]}</span>
                      </div>
                    </div>
                    <div className="cs-col-4 mob-fluid">
                      <div className="mul-input-field">
                        <label htmlFor="">Event Start Date & Time <sup>*</sup></label>
                        <DatePicker
                          selected={formData?.start_date_time}
                          onChange={(e) => handleFormChange({
                            target: {
                              name: 'start_date_time',
                              value: e
                            }
                          })}
                          dateFormat="MMMM d, yyyy h:mm aa"
                          showTimeSelect
                          timeIntervals={30}
                        />
                        <span className="error">{formSubmitted && errors["start_date_time"]}</span>
                      </div>
                    </div>
                    <div className="cs-col-4 mob-fluid">
                      <div className="mul-input-field">
                        <label htmlFor="">Event End Date & Time <sup>*</sup></label>
                        <DatePicker
                          selected={formData?.end_date_time}
                          onChange={(e) => handleFormChange({
                            target: {
                              name: 'end_date_time',
                              value: e
                            }
                          })}
                          dateFormat="MMMM d, yyyy h:mm aa"
                          showTimeSelect
                          timeIntervals={30}
                        />
                        <span className="error">{formSubmitted && errors["end_date_time"]}</span>
                      </div>
                    </div>
                    <div className="cs-col-2 tab-half-fluid mob-fluid">
                      <div className="mul-input-field">
                        <CustomSelect className="mh-32"
                          uniqueKey={'events-key'}
                          required={true}
                          data={[
                            {
                              id: 'public',
                              name: 'Public'
                            },
                            {
                              id: 'private',
                              name: 'Private'
                            }
                          ]}
                          label={'Type'}
                          placeholder={formData.type ? EVENT_STATUS[formData.type] : 'Public'}
                          onSelect={(e) => e && handleFormChange({
                            target: {
                              name: 'type',
                              value: e.id
                            }
                          })}
                          selector="name"
                        />
                        <span className="error">{formSubmitted && errors["type"]}</span>
                      </div>
                    </div>
                    {formData.type === 'public' && <div className="cs-col-2 tab-half-fluid mob-fluid">
                      <div className="mul-input-field">
                        <CustomSelect className="mh-32"
                          uniqueKey={'events-key'}
                          required={true}
                          data={[
                            {
                              id: 'paid',
                              name: 'Paid'
                            },
                            {
                              id: 'free',
                              name: 'Free'
                            }
                          ]}
                          label={'Paid Type'}
                          placeholder={formData.paid_type ? PAID_TYPE[formData.paid_type] : 'Select'}
                          onSelect={(e) => e && handleFormChange({
                            target: {
                              name: 'paid_type',
                              value: e.id
                            }
                          })}
                          selector="name"
                        />
                        <span className="error">{formSubmitted && errors["paid_type"]}</span>
                      </div>
                    </div>}
                    {formData.type === 'public' && formData.paid_type === 'paid' && <div className="cs-col-2 tab-half-fluid mob-fluid">
                      <div className="mul-input-field">
                        <label htmlFor="">Ticket Price <sup>*</sup></label>
                        <NumberFormat
                          placeholder=" "
                          onValueChange={(e) => handleFormChange({ target: { name: 'ticket_price', value: e.floatValue } })}
                          value={formData?.ticket_price}
                          decimalScale={2}
                          fixedDecimalScale={true}
                          allowNegative={false}
                          thousandsGroupStyle={['thousand']}
                          thousandSeparator={true}
                          disabled={false}
                          prefix='$'
                          name="ticket_price"
                          autoComplete="off"
                        />
                        <span className="error">{formSubmitted && errors["ticket_price"]}</span>
                      </div>
                    </div>}
                    <div className="cs-col-2 tab-half-fluid mob-fluid">
                      <div className="mul-input-field">
                        <CustomSelect className="mh-32"
                          uniqueKey={'events-key'}
                          required={true}
                          data={eventsOccasions}
                          label={'Occasion'}
                          placeholder={formData?.occasion ? formData?.occasion : 'Select an occasion'}
                          onSelect={(e) => e && handleFormChange({
                            target: {
                              name: 'occasion',
                              value: e.name
                            }
                          })}
                          selector="name"
                        />
                        <span className="error">{formSubmitted && errors["occasion"]}</span>
                      </div>
                    </div>
                    {formData.occasion === 'Other' && <div className="cs-col-2 tab-half-fluid mob-fluid">
                      {/* hide this field and make venue col to 4 */}
                      <div className="mul-input-field">
                        <label htmlFor="">Other Occasion  <sup>*</sup></label>
                        <input
                          name='other_occasion'
                          value={formData?.other_occasion}
                          onChange={(e) => handleFormChange(e)}
                          type="text"
                          placeholder=' '
                        />
                        <span className="error">{formSubmitted && errors["other_occasion"]}</span>
                      </div>
                    </div>}
                    {formData.occasion === 'Tournament' && <>
                      <div className="cs-col-2 tab-half-fluid mob-fluid">
                        <div className="mul-input-field">
                          <label htmlFor="">Team Type  <sup>*</sup></label>
                          <input
                            name='team_type'
                            value={formData?.team_type}
                            onChange={(e) => handleFormChange(e)}
                            type="text"
                            placeholder=' '
                          />
                          <span className="error">{formSubmitted && errors["team_type"]}</span>
                        </div>
                      </div>
                      <div className="cs-col-2 tab-half-fluid mob-fluid">
                        <div className="mul-input-field">
                          <label htmlFor="">Approx Teams  <sup>*</sup></label>
                          <input
                            name='approx_teams'
                            onChange={(e) => handleFormChange(e)}
                            value={formData?.approx_teams}
                            type="number"
                            placeholder='8'
                            min={0}
                            max={100}
                          />
                          <span className="error">{formSubmitted && errors["approx_teams"]}</span>
                        </div>
                      </div>
                    </>}
                    <div className="cs-col-2 tab-half-fluid mob-fluid">
                      <div className="mul-input-field">
                        <label htmlFor="">Budget</label>
                        <NumberFormat
                          placeholder=" "
                          onValueChange={(e) => handleFormChange({ target: { name: 'budget', value: e.floatValue } })}
                          value={formData?.budget}
                          decimalScale={2}
                          fixedDecimalScale={true}
                          allowNegative={false}
                          thousandsGroupStyle={['thousand']}
                          thousandSeparator={true}
                          disabled={false}
                          prefix='$'
                          name="budget"
                          autoComplete="off"
                        />
                        <span className="error">{formSubmitted && errors["budget"]}</span>
                      </div>
                    </div>
                    <div className="cs-col-2 tab-half-fluid mob-fluid">
                      <div className="mul-input-field">
                        <label htmlFor="">Number of {formData.type === 'public' ? 'Tickets' : 'Guests'}</label>
                        <input
                          name='no_of_guest'
                          onChange={(e) => handleFormChange(e)}
                          value={formData?.no_of_guest}
                          type="number"
                          placeholder='50'
                          min={0}
                        />
                        <span className="error">{formSubmitted && errors["no_of_guest"]}</span>
                      </div>
                    </div>
                    <div className={`cs-col-${formData.occasion === 'Other' ? '2' : '4'} tab-half-fluid mob-fluid cs-col-expand`}>
                      <div className="mul-input-field">
                        <CustomSelect
                          className="mh-32"
                          uniqueKey={'sports-key'}
                          required={true}
                          data={venues}
                          label={'Venue'}
                          placeholder={formData?.venue_id && formData?.venue_name ? formData?.venue_name : 'TBD'}
                          onSelect={(e) => e && handleFormChange({
                            target: {
                              name: 'venue_id',
                              value: e.id,
                              venue_name: e.name,
                            }
                          })}
                          selector="name"
                        />
                        <span className="error">{formSubmitted && errors["venue_id"]}</span>
                      </div>
                    </div>

                    {

                      formData.type === 'public' &&
                      <>
                        <div className="cs-col-4 mob-fluid">
                          <div className="mul-input-field">
                            <label htmlFor="">Booking Start Date</label>
                            <DatePicker
                              selected={formData?.booking_start_date}
                              onChange={(e) => handleFormChange({
                                target: {
                                  name: 'booking_start_date',
                                  value: e
                                }
                              })}
                            />
                            <span className="error">{formSubmitted && errors["booking_start_date"]}</span>
                          </div>
                        </div>
                        <div className="cs-col-4 mob-fluid">
                          <div className="mul-input-field">
                            <label htmlFor="">Booking Deadline</label>
                            <DatePicker
                              selected={formData?.booking_deadline}
                              onChange={(e) => handleFormChange({
                                target: {
                                  name: 'booking_deadline',
                                  value: e
                                }
                              })}
                            />
                            <span className="error">{formSubmitted && errors["booking_deadline"]}</span>
                          </div>
                        </div>
                      </>
                    }

                    <div className="cs-col-6">
                      <div className="mul-input-field">
                        <label htmlFor="">Event Details </label>
                        <TextEditor
                          value={formData?.detail || ''}
                          edit={true}
                          key={'add-eVeNt'}
                          type='events'
                          onChange={(e) => e && handleFormChange({
                            target: {
                              name: 'detail',
                              value: e
                            }
                          })}
                        />
                        <span className="error">{formSubmitted && errors["detail"]}</span>
                      </div>
                    </div>
                    <div className='cs-col-6'>
                      <div className="flex-blk recipients-field flex-blk-rs">
                        <span>Image</span>
                        <p>Select image to change</p>
                        <div className="img-input">
                          <label htmlFor="img">
                            {plusIcon}
                            {img}
                            <input id="img" type="file" name="image" onChange={(e) => onEventImgChange(e)} accept="image/*" />
                          </label>
                        </div>
                        <span className="error">{formSubmitted && errors["image"]}</span>
                      </div>
                    </div>
                    <div className="cs-col-12 new-sec-title">
                      <h2>Client Info</h2>
                    </div>
                    <div className="cs-col-3 tab-half-fluid mob-fluid">
                      <div className="mul-input-field">
                        <label htmlFor="">Client Name</label>
                        <input
                          type="text"
                          name='client_name'
                          onChange={(e) => handleFormChange(e)}
                          value={formData?.client_name}
                          placeholder='Enter name'
                        />
                        <span className="error">{formSubmitted && errors["client_name"]}</span>
                      </div>
                    </div>

                    <div className="cs-col-3 tab-half-fluid mob-fluid">
                      <div className="mul-input-field">
                        <label htmlFor="">Client Email</label>
                        <input
                          name='client_email'
                          onChange={(e) => handleFormChange(e)}
                          value={formData?.client_email}
                          type="email"
                          placeholder='email@example.com'
                        />
                        <span className="error">{formSubmitted && errors["client_email"]}</span>
                      </div>
                    </div>

                    <div className="cs-col-3 tab-half-fluid mob-fluid">
                      <div className="mul-input-field">
                        <label htmlFor="">Client Phone</label>
                        <NumberFormat
                          placeholder='Enter phone'
                          format={phoneNumberMask}
                          mask="_"
                          name="client_phone"
                          value={formData?.client_phone}
                          onChange={(e) => handleFormChange(e)}
                        />
                        <span className="error">{formSubmitted && errors["client_phone"]}</span>
                      </div>
                    </div>

                    <div className="cs-col-3 tab-half-fluid mob-fluid">
                      <div className="mul-input-field">
                        <label htmlFor="">Client Address</label>
                        <AutoPlaceComplete
                          getAddress={getPlace}
                          address={formData?.client_address}
                        />
                        <span className="error">{formSubmitted && errors["client_address"]}</span>
                      </div>
                    </div>
                    <div className="cs-col-12 new-sec-title">
                      <h2>Event Status</h2>
                    </div>
                    <div className="cs-col-2 tab-half-fluid mob-fluid">
                      <div className="mul-input-field">
                        <CustomSelect className="mh-32"
                          uniqueKey={'events-key'}
                          required={true}
                          data={[
                            {
                              id: 'active',
                              name: 'Active'
                            },
                            {
                              id: 'complete',
                              name: 'Complete'
                            },
                            {
                              id: 'delete',
                              name: 'Delete'
                            },
                          ]}
                          placeholder={formData.status ? LEAD_STATUS[formData.status] : 'active'}
                          onSelect={(e) => e && handleFormChange({
                            target: {
                              name: 'status',
                              value: e.id
                            }
                          })}
                          selector="name"
                        />
                        <span className="error">{formSubmitted && errors["type"]}</span>
                      </div>
                    </div>
                    <div className="cs-col-12 p-30">
                      <div className="btn-group btn-group-start">
                        <button onClick={() => handleSubmit()} className="btn btn-pri">
                          Save
                        </button>
                        <Link to="/admin/events" className="btn btn-sec"> Cancel </Link>
                      </div>
                    </div>
                  </div>
                </div >}
                {
                  /**
                   * 
                   * Documents Section
                   * 
                   **/
                }
                {
                  id && tab === 'doc' && <div className="mul-event-docs doc-with-dates">
                    <div className="cs-row">
                      <div className="cs-col-12 mul-doc-cards">
                        {docs.length > 0 && docs.map((doc, i) => {
                          const docUrl = doc.doc_url ? doc.doc_url : '';
                          return <div onClick={() => window.open(docUrl)} className="row-card" key={i}>
                            <div className="row-card-title">
                              <div className="row-card-icon">
                                <img src={fileIcon} alt="File Icon" />
                              </div>
                              <h3>
                                {doc?.doc_name}
                              </h3>
                            </div>
                            <div className="row-card-date">
                              <div className="card-date">
                                <span>Created On</span>
                                <p>{moment(doc?.created_at).format('MMMM Do, YYYY')}</p>
                              </div>
                            </div>
                            <div className="row-card-date">
                              {doc?.is_sent ? <div className="card-date">
                                <span>{doc?.created_by === 'user' ? 'Received on' : 'Last Sent Date'}</span>
                                <p>{moment(doc?.sent_date).format('MM/DD/YYYY')}</p>
                              </div> : ''}
                            </div>
                            <div className="row-card-actions">
                              <div className="btn-group">
                                <button className="btn with-icon" onClick={(e) => sendDocToClient(e, doc)}> <img src={sendIcon} alt="" />Send </button>
                                <button onClick={(e) => handleDelete(e, doc)} className="btn btn-sec with-icon"> <img src={trashIcon} alt="" /> Remove</button>
                                {/* {doc?.is_sent && <p>Last sent time: {doc?.sent_date}</p>} */}
                              </div>
                            </div>
                          </div>
                        })
                        }
                      </div >
                    </div >
                  </div >
                }
                {
                  tab === 'invoice' && <Invoice childFunc={childFunc} type="event" eventId={id} />
                }
                {
                  tab === 'ticket' && <Tickets isTicketInfo={isTicketInfoOpen} openCloseTicketInfo={showBackTicket} eventInfo={formData} eventId={id} type={props.type} scanTicket={scanTicket} />
                }
              </div >
            </div >
          </div >
        </div >
      </div >
      <Popup className='upload-popup' open={openFilePopup} closeOnDocumentClick={false}>
        <div className="mul-events-body">
          <span className="close" onClick={() => { setOpenFilePopup(false); setSavedDocs([]) }}>&times;</span>
          <h3>From where you want to upload?</h3>
          <div className="">
            <div className="btn-group">
              <label className="btn with-icon upload-btn">
                <input type="file" onChange={(e) => onFileChange(e)} name="file" id="upload-invoice" accept="image/png, image/jpeg, application/pdf" />
                Local Storage
              </label>
              <button className="btn with-icon upload-btn" onClick={() => handleSavedDocs()}>Saved</button>
            </div>
          </div>
          <div className={`upload-select-doc ${showSavedDocs ? 'show' : ''}`}>
            <h4>Select A Document :</h4>
            {
              showSavedDocs && savedDocs.length ?
                savedDocs.map((doc, i) => {
                  return <div onClick={(e) => savedDoc(doc)} className='select-doc-item'>
                    <span>{doc.title}</span>
                  </div>
                })
                : ''
            }
          </div>
        </div>
      </Popup>
      <WarningDialogue
        isOpen={openWarningPopup}
        header={popupContent.header}
        description={popupContent.description}
        icon={popupContent.icon}
        action={popupContent.action}
        onClose={() => setOpenWarningPopup(false)}
      />
    </>
  )
}
export default withRouter(AddEvent);